import { DefaultResponseWithData } from "../system";

export enum OmniSearchType {
  Vehicle,
  Lead,
  Order,
  Stock,
  User,
}

export interface OmniSearchResult {
  id: string;
  name: string;
  description: string | null;
  type: OmniSearchType | null;
  url: string | null;
  email: string | null;
  phone: string | null;
}

export interface OmniSearchResponse extends DefaultResponseWithData<OmniSearchResult[]> { }

export type VatScheme = "VAT" | "GLOBAL";

export interface OmniSearchVatResult {
  id: string;
  isVat: boolean | null;
  scheme: VatScheme | null;
  /** Resolved sales VAT treatment (1 = Standard, 2 = Margin scheme). */
  salesTreatment: number | null;
}

export interface OmniSearchVatResponse extends DefaultResponseWithData<OmniSearchVatResult[]> { }
